export default __webpack_public_path__ + "static/media/money_in_hand.615cd533.jpg";